export const sendSamplesDialogWarningsStrings = {
    alreadySentPre: 'Sie haben den Untersuchungsauftrag: "',
    alreadySentPost: '" bereits gesendet. Wollen Sie die Daten wirklich nochmal senden?',
    validationWarningsPre: 'Ihre Daten enthalten noch ',
    validationWarningsEmphasized: 'Warnungen',
    validationWarningsPost: '. Möchten Sie zurück zu den Daten und sie korrigieren?'
};

export const sendSamplesSendDialogStrings = {
    title: 'Senden',
    message: 'Ihre Probendaten werden jetzt an das BfR gesendet.'
        + ' Bitte vergessen Sie nicht, den Untersuchungsauftrag in Ihrem Mailanhang auszudrucken und Ihren Isolaten beizulegen.',
    confirmButtonLabel: 'Senden',
    confirmWithWarningsButtonLabel: 'Trotzdem senden',
    cancelButtonLabel: 'Zurück'
};

export const sendSamplesCommentWarningsStrings = {
    preamble: 'Warnung vom MiBi-Portal:',
    alreadySent: 'Der Untersuchungsauftrag wurde vom Benutzer in der selben Browser-Session bereits gesendet.'
};
